// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"XW-z","sponsoredTooltipWrapper":"YW-z","sponsoredTooltip":"ZW-z","newCard":"_W-z"};